import { useSelector } from "react-redux";
import { IRootState } from "../index";

/**
 * Use is authenticated hook
 */
export function useIsAuthenticated(): boolean {
  return useSelector((state: IRootState) => state.application.isAuthenticated);
}